import {Component, Input, OnInit} from '@angular/core';
import {User} from '../../model/user';
import {Version} from '../../model/version';

@Component({
    selector: 'mir-my-appointments',
    templateUrl: './my-appointments.component.html',
    styleUrls: ['./my-appointments.component.css'],
    standalone: false
})
export class MyAppointmentsComponent implements OnInit {

  @Input()
  user: User;

  @Input()
  version: Version;

  convocationsAvailable = false;
  bookingsAvailable = false;

  ngOnInit(): void {
    this.convocationsAvailable = this.version?.isAuthorized('CONVOCATION') && this.user.isAuthorized('OP_CONVOCATION');
    this.bookingsAvailable = this.version?.isAuthorized('MATERIEL') && this.user.isAuthorized('OP_BOOKING_READ');
  }

  get hasAnyContent(): boolean {
    return this.convocationsAvailable || this.bookingsAvailable;
  }
}
